// extracted by mini-css-extract-plugin
export var caption = "feature-vertical-tabs-module--caption--f499c";
export var feature = "feature-vertical-tabs-module--feature--f7b37";
export var featureSingle = "feature-vertical-tabs-module--featureSingle--251a0";
export var inactiveTab = "feature-vertical-tabs-module--inactiveTab--0063a";
export var root = "feature-vertical-tabs-module--root--d96ff";
export var tab = "feature-vertical-tabs-module--tab--556af";
export var tabs = "feature-vertical-tabs-module--tabs--cdf9c";
export var tabsWrapper = "feature-vertical-tabs-module--tabsWrapper--d3d94";